import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatCardModule } from '@angular/material/card';
import { MatSelectModule, MatSelect } from '@angular/material/select';
import { MatFormFieldModule, MatFormField } from '@angular/material/form-field';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { coerceNumberProperty } from '@angular/cdk/coercion';

import { TeamLoginService } from '../../auth/login/teamlogin.service';
import { DropDownDataService } from '../../logging/dropdown.service';
import { RecoverPalletService } from './recoverpallet.service';
import { TableDataService } from '../../table/table.service';
import { PortalService } from '../../../auth/portal.service';
import { TeamLoginComponent } from '../../auth/login/teamlogin.component';
import { MatOption } from '@angular/material/core';


@Component({
    selector: 'app-recoverpallet',
    templateUrl: './recoverpallet.component.html',
    styleUrls: ['./recoverpallet.component.scss'],
    imports: [MatFormField, MatSelect, FormsModule, MatOption, TeamLoginComponent]
})
export class RecoverPalletComponent implements OnInit {
	d: Date = new Date();

  constructor(
  	private lS: TeamLoginService,
  	public dDDS: DropDownDataService,
    public tableService: TableDataService,
    public rPService: RecoverPalletService,
    public pS: PortalService
  	) { }

  ngOnInit() {
    window.scrollTo(0,0);
    this.rPService.resetForm();
    this.dDDS.getDropdown("recoverPalletList");
  }

  ngOnDestroy() {
    this.rPService.resetForm();
  }

  isAuthenticated() {
    return this.lS.isAuthenticated();
  }

  canSave() {
    if (
        this.rPService.pallet!=""
      ) {
      return true;
    } else {
      return false;
    }
  }

  onCalculate() {
    if (this.canSave()) {
      this.rPService.recoverPallet();
      window.scroll(0,0);
      this.rPService.resetForm();
      this.dDDS.getDropdown("recoverPalletList");
    }
  }
  
}